import type { BinLink, Meeting } from './types';

const DAY_MS = 86_400_000;

export function binFor(meeting: Meeting, levelBp: number): BinLink | null {
    const exact = meeting.bins.find(b => b.deltaBp === levelBp);
    if (exact) return exact;
    return meeting.bins.find(b => b.levelBp === levelBp) ?? null;
}

export function eventPath(
    meeting: Meeting,
    opts: {
        levelBp?: number | null;
        range?: readonly [Date, Date] | null;
    } = {}
): string | null {
    if (!meeting.eventSlug) return null;
    const params = new URLSearchParams();
    if (opts.levelBp !== undefined && opts.levelBp !== null) {
        const bin = binFor(meeting, opts.levelBp);
        if (bin) params.set('markets', bin.conditionId);
    }
    if (opts.range) {
        const end = Math.min(
            opts.range[1].getTime(),
            meeting.decisionTs * 1000 + DAY_MS
        );
        const start = opts.range[0].getTime();
        if (end > start) {
            params.set('from', new Date(start).toISOString());
            params.set('to', new Date(end).toISOString());
        }
    }
    const query = params.toString();
    return `/markets/event/${meeting.eventSlug}${query ? `?${query}` : ''}`;
}

export function monitorPath(bank: string, meetingDate?: string | null): string {
    const base = `/monitor/pipr/${bank}`;
    return meetingDate ? `${base}?meeting=${meetingDate}` : base;
}
